import { environment } from 'src/environments/environment';

/** API base URL without trailing slashes. */
export const API_BASE_URL = environment.apiUrl.replace(/\/+$/, '');

/** True for requests to our API; a bare prefix check would also match e.g. `${base}.attacker.example`. */
export function isApiRequestUrl(url: string): boolean {
  return url === API_BASE_URL || url.startsWith(`${API_BASE_URL}/`);
}
